import * as React from 'react';
require('./style.css');

interface IProps {
	title?: string;
	subtitle?: string;
}

class InfoPage extends React.Component<IProps, {}> {
	/* RENDER */
	public render() {
		const { title, subtitle, children } = this.props;
		return (
			<div className="portalInfoPage">
				<h1 className="title">{title}</h1>
				<p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
				<div className="container">
					<div className="row">
						<div className="col-md-12 textWrapper">{children}</div>
					</div>
				</div>
			</div>
		);
	}
}
export { InfoPage };
